var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuesaxlinearlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies",
    transform: "translate(-814.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(814.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,14.1666667 L8.5,11.3333333 C8.5,6.64416675 9.91666667,2.83333333 17,2.83333333 C24.0833333,2.83333333 25.5,6.64416675 25.5,11.3333333 L25.5,14.1666667",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91666667,31.1666667 C4.25,31.1666667 2.83333333,29.75 2.83333333,24.0833333 L2.83333333,21.25 C2.83333333,15.5833333 4.25,14.1666667 9.91666667,14.1666667 L24.0833333,14.1666667 C29.75,14.1666667 31.1666667,15.5833333 31.1666667,21.25 L31.1666667,24.0833333 C31.1666667,29.75 29.75,31.1666667 24.0833333,31.1666667 L9.91666667,31.1666667 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "Vector",
    opacity: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.6616523,
    y1: 22.6666667,
    x2: 22.6743767,
    y2: 22.6666667,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9936022,
    y1: 22.6666667,
    x2: 17.0063266,
    y2: 22.6666667,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.325552,
    y1: 22.6666667,
    x2: 11.3382765,
    y2: 22.6666667,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxlinearlock);
export default __webpack_public_path__ + "static/media/vuesaxlinearlock.0072bd7725ac706320ebac2e08d94ec0.svg";
export { ForwardRef as ReactComponent };